import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import LoginForm from './../block/LoginForm'
import Breadcrumbs from './../block/Breadcrumbs'
import LkSidebar from './../block/LkSidebar'
import LegalProducts from './../block/LegalProducts'

import { Container } from 'react-bootstrap'

import styles from './../style/Lk.module.scss'

export default class Lk extends Component {

  static defaultProps = {
    cart: []
  }

  constructor(props) {
    super(props)

    this.state = {
      cartCount: props.cart.reduce((total, item) => total + item.count, 0)
    }
  }

  logOut() {
    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'logout'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        location.reload()
      }
    })
  }

  render() {
    const { ajax_data, data, authorized, loading_user, cart, addTocart, user_profile_type } = this.props,
    { cartCount } = this.state

    if (loading_user) {
      return (
        <>
          <Breadcrumbs items={ajax_data.breadcrumbs} />
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <Container className={styles.container + ' text-center'}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </Container>
          </div>
        </>
      )
    }

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              {authorized ?
                <>
                  <Breadcrumbs items={ajax_data.breadcrumbs} />
                  <div className={styles.lk_page}>
                    <Container className={styles.container}>
                      <h1>{ajax_data.pagetitle}</h1>
                      <div className={styles.lk_page_block}>
                        <LkSidebar 
                          data={data} 
                          cartCount={cartCount} 
                          logOut={() => this.logOut()} 
                          active={5}
                          user_profile_type={user_profile_type}
                        />
                        <div className={styles.lk_page_block_right}>
                          <LegalProducts
                            products={ajax_data?.ulcatalog || []}
                            cart={cart}
                            addTocart={addTocart}
                            authorized={authorized}
                          />
                        </div>
                      </div>
                    </Container>
                  </div>
                </>
              :
                <>
                  <Breadcrumbs
                    items={[
                      {
                        id: 99,
                        pagetitle: `Вход в учетную запись`,
                        is_current: true
                      }
                    ]}
                  />
                  <LoginForm
                    ajax_data={ajax_data}
                    user_profile_type={user_profile_type}
                  />
                </>
              }
            </>
          }
        </div>
      </>
    )
  }
}

Lk.propTypes = {
  ajax_data: PropTypes.object,
  data: PropTypes.object,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user: PropTypes.object,
  authorized: PropTypes.bool,
  loading_user: PropTypes.bool,
  user_profile_type: PropTypes.string
}